<ng-container *ngIf="!errorLoadRoles">
    <div class="flex w-full">
        <app-custom-select [selectForm]="form"
                           [formField]="field"
                           [label]="'Wallet ETH address'"
                           [isInfinityScroll]="true"
                           (infiniteScroll)="scrollItems($event)"
                           (autocomplete)="autocompleteItems($event)"
                           [isItemsScroll]="isItemsScroll"
                           [showAutoLoading]="showAutoLoading"
                           [isAutocomplete]="true"
                           [items]="items$"
                           [required]="required"
                           [showClearIcon]="showClearIcon"
                           [multi]="false">
        </app-custom-select>
<!--                           (changed)="selected($event)"-->
        <ng-container *ngIf="!(items$ | async)?.length && showAutoLoading">
            <div class="flex align-items-center">
                <mat-progress-spinner
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
            </div>
        </ng-container>
    </div>
</ng-container>
